// frontend/src/components/modules/certificaciones/CertificacionesModule.jsx
import React, { useState, useEffect, useRef } from 'react';
import { useAuth } from '../../../context/AuthContext';
import certificacionesService from '../../../api/certificacionesService';
import { showNotification } from '@mantine/notifications';

const API_URL    = process.env.REACT_APP_API_URL || '';
const UPLOADS_URL = API_URL.replace(/\/api$/, ''); // → https://protalenthub.prodominicana.gob.do

const C = {
  navy: '#0a2540', navyMid: '#0d3a5c', blue: '#1e5cb3', blueLight: '#eff6ff',
  border: '#e2e8f0', bg: '#f8fafc', bgCard: '#ffffff',
  text: '#0f172a', textMid: '#334155', textSub: '#64748b', textLight: '#94a3b8',
  green: '#16a34a', greenBg: '#f0fdf4', greenBorder: '#bbf7d0',
  amber: '#b45309', amberBg: '#fffbeb', amberBorder: '#fde68a',
  red: '#dc2626', redBg: '#fef2f2', redBorder: '#fecaca',
};

const TIPOS = [
  { id: 'interesar', label: 'A Quien Pueda Interesar', descripcion: 'Certificación de carácter general', necesitaEspecificacion: false },
  { id: 'banco',     label: 'Certificación Bancaria',  descripcion: 'Para trámites con entidades financieras', necesitaEspecificacion: true, placeholder: 'Ej: Banco BHD, Banco Popular...' },
  { id: 'embajada',  label: 'Embajada / Consulado',    descripcion: 'Para trámites de visa u otros consulares', necesitaEspecificacion: true, placeholder: 'Ej: Embajada de Estados Unidos...' },
];

const TIPO_LABEL = { interesar: 'A Quien Pueda Interesar', banco: 'Certificación Bancaria', embajada: 'Embajada / Consulado' };

const ESTADO_CONFIG = {
  Pendiente:    { color: C.amber, bg: C.amberBg,  border: C.amberBorder, dot: '#f59e0b', label: 'Pendiente'  },
  'En Proceso': { color: C.blue,  bg: C.blueLight, border: '#bfdbfe',    dot: C.blue,    label: 'En Proceso' },
  Completada:   { color: C.green, bg: C.greenBg,  border: C.greenBorder, dot: C.green,   label: 'Completada' },
  Rechazada:    { color: C.red,   bg: C.redBg,    border: C.redBorder,   dot: C.red,     label: 'Rechazada'  },
};

const ROLES_DTHS = ['dths_analista', 'dths_coordinador', 'dths_gerente', 'dths_director'];
const ESTADO_INICIAL_FORM = { tipo: '', especificacion: '', comentarios: '' };

const VARIABLES = [
  { key: '{{nombre}}',          label: 'Nombre completo'    },
  { key: '{{cargo}}',           label: 'Cargo / Puesto'     },
  { key: '{{departamento}}',    label: 'Departamento'       },
  { key: '{{fecha_ingreso}}',   label: 'Fecha de ingreso'   },
  { key: '{{tiempo_servicio}}', label: 'Tiempo de servicio' },
  { key: '{{salario}}',         label: 'Salario mensual'    },
  { key: '{{entidad}}',         label: 'Entidad solicitada' },
  { key: '{{fecha}}',           label: 'Fecha actual'       },
  { key: '{{numero_cert}}',     label: 'Nº de certificación'},
];

// ── ICONOS ────────────────────────────────────────────────────
const IconSend    = () => <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><line x1="22" y1="2" x2="11" y2="13"/><polygon points="22 2 15 22 11 13 2 9 22 2"/></svg>;
const IconCheck   = () => <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke={C.green} strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><polyline points="20 6 9 17 4 12"/></svg>;
const IconRefresh = () => <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><polyline points="23 4 23 10 17 10"/><polyline points="1 20 1 14 7 14"/><path d="M3.51 9a9 9 0 0 1 14.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0 0 20.49 15"/></svg>;
const IconInfo    = () => <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></svg>;
const IconNote    = () => <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/><line x1="16" y1="13" x2="8" y2="13"/><line x1="16" y1="17" x2="8" y2="17"/></svg>;
const IconCalendar= () => <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="4" width="18" height="18" rx="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/></svg>;
const IconPrint   = () => <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="6 9 6 2 18 2 18 9"/><path d="M6 18H4a2 2 0 0 1-2-2v-5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-2"/><rect x="6" y="14" width="12" height="8"/></svg>;
const IconUpload  = () => <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="16 16 12 12 8 16"/><line x1="12" y1="12" x2="12" y2="21"/><path d="M20.39 18.39A5 5 0 0 0 18 9h-1.26A8 8 0 1 0 3 16.3"/></svg>;
const IconEdit    = () => <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/><path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"/></svg>;
const IconTrash   = () => <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="3 6 5 6 21 6"/><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2"/></svg>;
const IconFile    = () => <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/></svg>;
const IconPlus    = () => <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>;

// ── HELPERS ───────────────────────────────────────────────────
function formatFecha(iso) {
  if (!iso) return '—';
  return new Date(iso).toLocaleDateString('es-DO', { day: '2-digit', month: 'short', year: 'numeric' });
}

function llenarVariables(template, variables) {
  return Object.entries(variables).reduce(
    (html, [key, val]) => html.replaceAll(`{{${key}}}`, val || '—'),
    template
  );
}

function EstadoBadge({ estado }) {
  const cfg = ESTADO_CONFIG[estado] || ESTADO_CONFIG['Pendiente'];
  return (
    <span style={{ display: 'inline-flex', alignItems: 'center', gap: '0.35rem', padding: '0.2rem 0.65rem', borderRadius: '9999px', fontSize: '0.75rem', fontWeight: '600', background: cfg.bg, color: cfg.color, border: `1px solid ${cfg.border}` }}>
      <span style={{ width: '6px', height: '6px', borderRadius: '50%', background: cfg.dot, flexShrink: 0 }} />
      {cfg.label}
    </span>
  );
}

function Spinner() {
  return <span style={{ width: '14px', height: '14px', border: '2px solid rgba(255,255,255,0.35)', borderTopColor: 'white', borderRadius: '50%', animation: 'spin 0.7s linear infinite', display: 'inline-block' }} />;
}

// ═══════════════════════════════════════════════════════════════
// MODAL: GENERAR CERTIFICACIÓN
// ═══════════════════════════════════════════════════════════════
function ModalGenerarCertificacion({ solicitud, onClose, onDocumentoSubido }) {
  const [plantillas, setPlantillas]       = useState([]);
  const [plantillaId, setPlantillaId]     = useState(null);
  const [variables, setVariables]         = useState(null);
  const [htmlPreview, setHtmlPreview]     = useState('');
  const [cargando, setCargando]           = useState(true);
  const [subiendo, setSubiendo]           = useState(false);
  const [archivoFirmado, setArchivoFirmado] = useState(null);
  const fileRef = useRef();

  useEffect(() => {
    cargarDatos();
  }, []);

  useEffect(() => {
    if (plantillaId && variables) {
      const plantilla = plantillas.find(p => p.PlantillaID === plantillaId);
      if (plantilla) setHtmlPreview(llenarVariables(plantilla.Contenido, variables));
    }
  }, [plantillaId, variables, plantillas]);

  const cargarDatos = async () => {
    try {
     const [datosResp, plantillasResp] = await Promise.all([
        certificacionesService.getDatosEmpleado(solicitud.CertificacionID),
        certificacionesService.getPlantillas(solicitud.Tipo),
      ]);
      setVariables(datosResp.variables);
      setPlantillas(plantillasResp || []);

      setVariables(datosResp.variables);
      setPlantillas(plantillasResp || []);

      // Seleccionar predeterminada o la primera
      const pred = (plantillasResp || []).find(p => p.EsPredeterminada) || plantillasResp?.[0];
      if (pred) setPlantillaId(pred.PlantillaID);

    } catch (e) {
      showNotification({ title: 'Error', message: 'Error al cargar datos', color: 'red' });
    } finally {
      setCargando(false);
    }
  };

  const imprimir = () => {
    const ventana = window.open('', '_blank');
    ventana.document.write(`<!DOCTYPE html><html><head><meta charset="UTF-8">
      <title>Certificación Laboral</title>
      <style>
        @media print { body { margin: 0; } }
        body { font-family: 'Times New Roman', serif; }
      </style>
    </head><body>${htmlPreview}</body></html>`);
    ventana.document.close();
    ventana.focus();
    setTimeout(() => { ventana.print(); }, 300);
  };

  const subirFirmado = async () => {
    if (!archivoFirmado) return;
    setSubiendo(true);
    try {
      await certificacionesService.subirDocumentoFirmado(solicitud.CertificacionID, archivoFirmado);
      showNotification({ title: 'Éxito', message: 'Documento firmado adjuntado correctamente', color: 'green' });
      onDocumentoSubido();
      onClose();
    } catch (e) {
      showNotification({ title: 'Error', message: e?.response?.data?.error || 'Error al subir el documento', color: 'red' });
    } finally {
      setSubiendo(false);
    }
  };

  return (
    <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.55)', display: 'flex', alignItems: 'flex-start', justifyContent: 'center', zIndex: 1000, padding: '2rem 1rem', overflowY: 'auto' }}>
      <div style={{ background: 'white', borderRadius: '1rem', width: '100%', maxWidth: '860px', boxShadow: '0 20px 60px rgba(0,0,0,0.2)' }}>

        {/* Header */}
        <div style={{ background: `linear-gradient(135deg, ${C.navy} 0%, ${C.blue} 100%)`, padding: '1.25rem 1.75rem', borderRadius: '1rem 1rem 0 0', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <div>
            <p style={{ margin: 0, fontSize: '0.65rem', fontWeight: '700', color: 'rgba(255,255,255,0.5)', textTransform: 'uppercase', letterSpacing: '0.1em' }}>Generar Certificación</p>
            <h3 style={{ margin: '0.2rem 0 0', fontSize: '1rem', fontWeight: '700', color: 'white' }}>{solicitud.Colaborador}</h3>
          </div>
          <button onClick={onClose} style={{ background: 'rgba(255,255,255,0.1)', border: '1px solid rgba(255,255,255,0.2)', color: 'white', width: '32px', height: '32px', borderRadius: '50%', cursor: 'pointer', fontSize: '1.1rem', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>×</button>
        </div>

        <div style={{ padding: '1.5rem 1.75rem' }}>
          {cargando ? (
            <div style={{ textAlign: 'center', padding: '3rem', color: C.textSub }}>Cargando datos del empleado...</div>
          ) : (
            <>
              {/* Selector de plantilla */}
              {plantillas.length > 0 && (
                <div style={{ marginBottom: '1.25rem' }}>
                  <label style={{ display: 'block', fontSize: '0.75rem', fontWeight: '700', color: C.textMid, textTransform: 'uppercase', letterSpacing: '0.06em', marginBottom: '0.5rem' }}>
                    Plantilla
                  </label>
                  <div style={{ display: 'flex', gap: '0.5rem', flexWrap: 'wrap' }}>
                    {plantillas.map(p => (
                      <button key={p.PlantillaID} onClick={() => setPlantillaId(p.PlantillaID)} style={{
                        padding: '0.4rem 1rem', border: `1.5px solid ${plantillaId === p.PlantillaID ? C.blue : C.border}`,
                        borderRadius: '0.4rem', fontSize: '0.8rem', fontWeight: '600', cursor: 'pointer',
                        background: plantillaId === p.PlantillaID ? C.blueLight : 'white',
                        color: plantillaId === p.PlantillaID ? C.blue : C.textSub,
                      }}>
                        {p.EsPredeterminada ? '(Predeterminada) ' : ''}{p.Nombre}
                      </button>
                    ))}
                  </div>
                </div>
              )}

              {/* Preview */}
              {htmlPreview && (
                <div style={{ border: `1px solid ${C.border}`, borderRadius: '0.5rem', overflow: 'hidden', marginBottom: '1.5rem' }}>
                  <div style={{ background: C.bg, padding: '0.6rem 1rem', borderBottom: `1px solid ${C.border}`, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <span style={{ fontSize: '0.75rem', fontWeight: '600', color: C.textSub }}>Vista previa del documento</span>
                    <button onClick={imprimir} style={{ display: 'flex', alignItems: 'center', gap: '0.4rem', padding: '0.4rem 1rem', background: C.navy, border: 'none', borderRadius: '0.375rem', color: 'white', fontSize: '0.78rem', fontWeight: '600', cursor: 'pointer' }}>
                      <IconPrint /> Imprimir
                    </button>
                  </div>
                  <div style={{ background: 'white', padding: '1rem', maxHeight: '420px', overflowY: 'auto' }}
                    dangerouslySetInnerHTML={{ __html: htmlPreview }} />
                </div>
              )}

              {/* Subir documento firmado */}
              <div style={{ background: C.bg, border: `1px solid ${C.border}`, borderRadius: '0.65rem', padding: '1.25rem' }}>
                <p style={{ margin: '0 0 0.75rem', fontSize: '0.82rem', fontWeight: '700', color: C.textMid }}>
                  Adjuntar documento firmado
                </p>
                <p style={{ margin: '0 0 0.75rem', fontSize: '0.78rem', color: C.textSub }}>
                  Una vez impreso y firmado, adjunte el documento escaneado (PDF, JPG o PNG, máx. 10MB). Esto marcará la solicitud como Completada.
                </p>

                {solicitud.DocumentoFirmadoPath ? (
                  <div style={{ display: 'flex', alignItems: 'center', gap: '0.65rem', padding: '0.65rem 1rem', background: C.greenBg, border: `1px solid ${C.greenBorder}`, borderRadius: '0.45rem', fontSize: '0.82rem', color: C.green, fontWeight: '600' }}>
                    <IconFile /> Documento ya adjuntado
                    <a href={`${UPLOADS_URL}/uploads/${solicitud.DocumentoFirmadoPath}`} target="_blank" rel="noopener noreferrer"
                      style={{ marginLeft: 'auto', color: C.green, fontSize: '0.75rem' }}>Ver archivo</a>
                  </div>
                ) : (
                  <div style={{ display: 'flex', gap: '0.75rem', alignItems: 'center', flexWrap: 'wrap' }}>
                    <input ref={fileRef} type="file" accept=".pdf,.jpg,.jpeg,.png" style={{ display: 'none' }}
                      onChange={e => setArchivoFirmado(e.target.files?.[0] || null)} />
                    <button onClick={() => fileRef.current?.click()} style={{ display: 'flex', alignItems: 'center', gap: '0.4rem', padding: '0.5rem 1rem', border: `1.5px dashed ${C.border}`, borderRadius: '0.45rem', background: 'white', color: C.textSub, fontSize: '0.8rem', cursor: 'pointer', fontWeight: '600' }}>
                      <IconUpload /> {archivoFirmado ? archivoFirmado.name : 'Seleccionar archivo'}
                    </button>
                    {archivoFirmado && (
                      <button onClick={subirFirmado} disabled={subiendo} style={{ display: 'flex', alignItems: 'center', gap: '0.4rem', padding: '0.5rem 1.1rem', background: C.green, border: 'none', borderRadius: '0.45rem', color: 'white', fontSize: '0.8rem', fontWeight: '600', cursor: subiendo ? 'not-allowed' : 'pointer' }}>
                        {subiendo ? <Spinner /> : <IconUpload />} {subiendo ? 'Subiendo...' : 'Adjuntar'}
                      </button>
                    )}
                  </div>
                )}
              </div>
            </>
          )}
        </div>
      </div>
      <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
    </div>
  );
}

// ═══════════════════════════════════════════════════════════════
// GESTIÓN DE PLANTILLAS
// ═══════════════════════════════════════════════════════════════
function GestionPlantillas({ user }) {
  const [plantillas, setPlantillas]   = useState([]);
  const [cargando, setCargando]       = useState(true);
  const [editando, setEditando]       = useState(null); // null | 'nueva' | {PlantillaID,...}
  const [form, setForm]               = useState({ nombre: '', tipoAplicable: 'todos', contenido: '', esPredeterminada: false });
  const [guardando, setGuardando]     = useState(false);
  const [errorMsg, setErrorMsg]       = useState(null);
  const textareaRef                   = useRef();

  useEffect(() => { cargar(); }, []);

 const cargar = async () => {
  try {
    setCargando(true);
    setErrorMsg(null);
    const data = await certificacionesService.getPlantillas();
    setPlantillas(data || []);
  } catch (e) {
    setErrorMsg('Error al cargar plantillas: ' + (e?.response?.data?.error || e.message));
    showNotification({ title: 'Error', message: 'Error al cargar plantillas', color: 'red' });
  } finally {
    setCargando(false);
  }
};

  const abrirNueva = () => {
    setForm({ nombre: '', tipoAplicable: 'todos', contenido: '', esPredeterminada: false });
    setEditando('nueva');
  };

  const abrirEditar = (p) => {
    setForm({ nombre: p.Nombre, tipoAplicable: p.TipoAplicable, contenido: p.Contenido, esPredeterminada: !!p.EsPredeterminada });
    setEditando(p);
  };

  const insertarVariable = (variable) => {
    const ta = textareaRef.current;
    if (!ta) return;
    const start = ta.selectionStart;
    const end   = ta.selectionEnd;
    const nuevo = form.contenido.slice(0, start) + variable + form.contenido.slice(end);
    setForm(p => ({ ...p, contenido: nuevo }));
    setTimeout(() => { ta.focus(); ta.setSelectionRange(start + variable.length, start + variable.length); }, 0);
  };
const guardar = async () => {
  if (!form.nombre.trim() || !form.contenido.trim()) {
    showNotification({ title: 'Error', message: 'Nombre y contenido son requeridos', color: 'red' });
    return;
  }
  setGuardando(true);
  try {
    const payload = { nombre: form.nombre, tipoAplicable: form.tipoAplicable, contenido: form.contenido, esPredeterminada: form.esPredeterminada };
    if (editando === 'nueva') {
      await certificacionesService.crearPlantilla(payload);
    } else {
      await certificacionesService.actualizarPlantilla(editando.PlantillaID, payload);
    }
    showNotification({ title: 'Éxito', message: editando === 'nueva' ? 'Plantilla creada' : 'Plantilla actualizada', color: 'green' });
    setEditando(null);
    await cargar();
  } catch (e) {
    showNotification({ title: 'Error', message: e?.response?.data?.error || e.message, color: 'red' });
  } finally { setGuardando(false); }
};

const eliminar = async (id) => {
  if (!window.confirm('¿Eliminar esta plantilla?')) return;
  try {
    await certificacionesService.eliminarPlantilla(id);
    showNotification({ title: 'Éxito', message: 'Plantilla eliminada', color: 'green' });
    await cargar();
  } catch (e) {
    showNotification({ title: 'Error', message: e?.response?.data?.error || e.message, color: 'red' });
  }
};

  const TIPO_OPTIONS = [
    { value: 'todos',    label: 'Todos los tipos'       },
    { value: 'interesar',label: 'A Quien Pueda Interesar'},
    { value: 'banco',    label: 'Certificación Bancaria' },
    { value: 'embajada', label: 'Embajada / Consulado'  },
  ];

  if (editando) {
    return (
      <div>
        <div style={{ display: 'flex', alignItems: 'center', gap: '1rem', marginBottom: '1.5rem' }}>
          <button onClick={() => setEditando(null)} style={{ background: 'none', border: `1px solid ${C.border}`, borderRadius: '0.375rem', padding: '0.35rem 0.75rem', fontSize: '0.8rem', cursor: 'pointer', color: C.textSub }}>
            ← Volver
          </button>
          <h3 style={{ margin: 0, fontSize: '1rem', fontWeight: '700', color: C.text }}>
            {editando === 'nueva' ? 'Nueva plantilla' : `Editar: ${editando.Nombre}`}
          </h3>
        </div>

        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '1rem', marginBottom: '1rem' }}>
          <div>
            <label style={{ display: 'block', fontSize: '0.75rem', fontWeight: '700', color: C.textMid, textTransform: 'uppercase', letterSpacing: '0.06em', marginBottom: '0.4rem' }}>Nombre *</label>
            <input type="text" value={form.nombre} onChange={e => setForm(p => ({ ...p, nombre: e.target.value }))}
              placeholder="Ej: Certificación General ProDominicana"
              style={{ width: '100%', padding: '0.65rem 0.9rem', border: `1.5px solid ${C.border}`, borderRadius: '0.45rem', fontSize: '0.875rem', outline: 'none', boxSizing: 'border-box' }}
              onFocus={e => e.target.style.borderColor = C.blue} onBlur={e => e.target.style.borderColor = C.border} />
          </div>
          <div>
            <label style={{ display: 'block', fontSize: '0.75rem', fontWeight: '700', color: C.textMid, textTransform: 'uppercase', letterSpacing: '0.06em', marginBottom: '0.4rem' }}>Aplica para</label>
            <select value={form.tipoAplicable} onChange={e => setForm(p => ({ ...p, tipoAplicable: e.target.value }))}
              style={{ width: '100%', padding: '0.65rem 0.9rem', border: `1.5px solid ${C.border}`, borderRadius: '0.45rem', fontSize: '0.875rem', outline: 'none' }}>
              {TIPO_OPTIONS.map(o => <option key={o.value} value={o.value}>{o.label}</option>)}
            </select>
          </div>
        </div>

        {/* Variables disponibles */}
        <div style={{ marginBottom: '0.75rem' }}>
          <label style={{ display: 'block', fontSize: '0.75rem', fontWeight: '700', color: C.textMid, textTransform: 'uppercase', letterSpacing: '0.06em', marginBottom: '0.5rem' }}>
            Variables disponibles — haz clic para insertar en el cursor
          </label>
          <div style={{ display: 'flex', flexWrap: 'wrap', gap: '0.4rem' }}>
            {VARIABLES.map(v => (
              <button key={v.key} onClick={() => insertarVariable(v.key)}
                style={{ padding: '0.25rem 0.65rem', background: C.blueLight, border: `1px solid #bfdbfe`, borderRadius: '9999px', fontSize: '0.72rem', fontWeight: '600', color: C.blue, cursor: 'pointer', fontFamily: 'monospace' }}>
                {v.key}
              </button>
            ))}
          </div>
        </div>

        {/* Editor de contenido */}
        <div style={{ marginBottom: '1rem' }}>
          <label style={{ display: 'block', fontSize: '0.75rem', fontWeight: '700', color: C.textMid, textTransform: 'uppercase', letterSpacing: '0.06em', marginBottom: '0.4rem' }}>
            Contenido HTML *
          </label>
          <textarea ref={textareaRef} value={form.contenido} onChange={e => setForm(p => ({ ...p, contenido: e.target.value }))} rows={16}
            placeholder="Escribe el HTML de la certificación. Usa las variables de arriba para datos dinámicos."
            style={{ width: '100%', padding: '0.75rem', border: `1.5px solid ${C.border}`, borderRadius: '0.5rem', fontSize: '0.8rem', fontFamily: 'monospace', lineHeight: '1.6', resize: 'vertical', outline: 'none', boxSizing: 'border-box' }}
            onFocus={e => e.target.style.borderColor = C.blue} onBlur={e => e.target.style.borderColor = C.border} />
        </div>

        {/* Preview en tiempo real */}
        {form.contenido && (
          <div style={{ marginBottom: '1rem', border: `1px solid ${C.border}`, borderRadius: '0.5rem', overflow: 'hidden' }}>
            <div style={{ background: C.bg, padding: '0.5rem 1rem', borderBottom: `1px solid ${C.border}`, fontSize: '0.72rem', fontWeight: '700', color: C.textSub, textTransform: 'uppercase', letterSpacing: '0.06em' }}>
              Vista previa (con datos de ejemplo)
            </div>
            <div style={{ background: 'white', padding: '1rem', maxHeight: '300px', overflowY: 'auto', fontSize: '13px' }}
              dangerouslySetInnerHTML={{ __html: llenarVariables(form.contenido, {
                nombre: 'Juan Pérez García', cargo: 'Analista de Sistemas', departamento: 'Tecnología',
                fecha_ingreso: '15 de enero de 2020', tiempo_servicio: '4 años y 3 meses',
                salario: 'DOP 65,000.00', entidad: 'Entidad de Ejemplo', fecha: '15 de mayo de 2025',
                numero_cert: 'CERT-2025-0001',
              }) }} />
          </div>
        )}

        <div style={{ display: 'flex', alignItems: 'center', gap: '1rem', justifyContent: 'space-between' }}>
          <label style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', fontSize: '0.82rem', color: C.textMid, cursor: 'pointer' }}>
            <input type="checkbox" checked={form.esPredeterminada} onChange={e => setForm(p => ({ ...p, esPredeterminada: e.target.checked }))} />
            Usar como plantilla predeterminada para este tipo
          </label>
          <div style={{ display: 'flex', gap: '0.5rem' }}>
            <button onClick={() => setEditando(null)} style={{ padding: '0.55rem 1.25rem', background: 'white', border: `1px solid ${C.border}`, borderRadius: '0.45rem', fontSize: '0.85rem', cursor: 'pointer', color: C.textSub }}>
              Cancelar
            </button>
            <button onClick={guardar} disabled={guardando} style={{ padding: '0.55rem 1.5rem', background: C.navy, border: 'none', borderRadius: '0.45rem', color: 'white', fontSize: '0.85rem', fontWeight: '700', cursor: guardando ? 'not-allowed' : 'pointer', display: 'flex', alignItems: 'center', gap: '0.4rem' }}>
              {guardando ? <Spinner /> : null} {guardando ? 'Guardando...' : 'Guardar plantilla'}
            </button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1.5rem' }}>
        <div>
          <h3 style={{ margin: '0 0 0.2rem', fontSize: '1rem', fontWeight: '700', color: C.text }}>Plantillas de Certificación</h3>
          <p style={{ margin: 0, fontSize: '0.8rem', color: C.textSub }}>Crea y personaliza las plantillas que se usan para generar los documentos.</p>
        </div>
        <button onClick={abrirNueva} style={{ display: 'flex', alignItems: 'center', gap: '0.4rem', padding: '0.55rem 1.25rem', background: C.navy, border: 'none', borderRadius: '0.5rem', color: 'white', fontSize: '0.82rem', fontWeight: '700', cursor: 'pointer' }}>
          <IconPlus /> Nueva plantilla
        </button>
      </div>

      {cargando ? (
        <p style={{ color: C.textSub, fontSize: '0.875rem' }}>Cargando plantillas...</p>
      ) : plantillas.length === 0 ? (
        <div style={{ textAlign: 'center', padding: '3rem', background: C.bgCard, border: `1px dashed ${C.border}`, borderRadius: '0.75rem' }}>
          <p style={{ color: C.textSub, margin: '0 0 1rem' }}>No hay plantillas creadas todavía.</p>
          <button onClick={abrirNueva} style={{ padding: '0.55rem 1.5rem', background: C.navy, border: 'none', borderRadius: '0.45rem', color: 'white', fontSize: '0.85rem', fontWeight: '700', cursor: 'pointer' }}>
            Crear primera plantilla
          </button>
        </div>
      ) : (
        <div style={{ display: 'flex', flexDirection: 'column', gap: '0.65rem' }}>
          {plantillas.map(p => (
            <div key={p.PlantillaID} style={{ background: C.bgCard, border: `1px solid ${C.border}`, borderRadius: '0.75rem', padding: '1.1rem 1.4rem', display: 'flex', alignItems: 'center', gap: '1rem', boxShadow: '0 1px 4px rgba(0,0,0,0.04)' }}>
              <div style={{ flex: 1, minWidth: 0 }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', marginBottom: '0.2rem' }}>
                  <p style={{ margin: 0, fontSize: '0.9rem', fontWeight: '700', color: C.text }}>{p.Nombre}</p>
                  {p.EsPredeterminada && (
                    <span style={{ padding: '0.1rem 0.5rem', background: C.amberBg, border: `1px solid ${C.amberBorder}`, borderRadius: '9999px', fontSize: '0.65rem', fontWeight: '700', color: C.amber }}>PREDETERMINADA</span>
                  )}
                </div>
                <p style={{ margin: 0, fontSize: '0.75rem', color: C.textSub }}>
                  Aplica para: <strong>{TIPO_OPTIONS_LABEL[p.TipoAplicable] || p.TipoAplicable}</strong>
                  {p.CreadoPor && ` · Creada por ${p.CreadoPor}`}
                </p>
              </div>
              <div style={{ display: 'flex', gap: '0.4rem', flexShrink: 0 }}>
                <button onClick={() => abrirEditar(p)} style={{ display: 'flex', alignItems: 'center', gap: '0.35rem', padding: '0.4rem 0.85rem', border: `1px solid ${C.border}`, borderRadius: '0.375rem', background: 'white', color: C.textSub, fontSize: '0.78rem', fontWeight: '600', cursor: 'pointer' }}>
                  <IconEdit /> Editar
                </button>
                <button onClick={() => eliminar(p.PlantillaID)} style={{ display: 'flex', alignItems: 'center', gap: '0.35rem', padding: '0.4rem 0.85rem', border: `1px solid ${C.redBorder}`, borderRadius: '0.375rem', background: C.redBg, color: C.red, fontSize: '0.78rem', fontWeight: '600', cursor: 'pointer' }}>
                  <IconTrash /> Eliminar
                </button>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

const TIPO_OPTIONS_LABEL = { todos: 'Todos los tipos', interesar: 'A Quien Pueda Interesar', banco: 'Certificación Bancaria', embajada: 'Embajada / Consulado' };

// ═══════════════════════════════════════════════════════════════
// VISTA COLABORADOR
// ═══════════════════════════════════════════════════════════════
function VistaColaborador({ user }) {
  const [form, setForm]           = useState(ESTADO_INICIAL_FORM);
  const [enviado, setEnviado]     = useState(false);
  const [enviando, setEnviando]   = useState(false);
  const [error, setError]         = useState(null);
  const [entrega, setEntrega]     = useState(null);
  const [historial, setHistorial] = useState([]);
  const [cargando, setCargando]   = useState(true);
  const [tab, setTab]             = useState('solicitar');

  const tipoSel     = TIPOS.find(t => t.id === form.tipo);
  const puedeEnviar = form.tipo !== '' && (!tipoSel?.necesitaEspecificacion || form.especificacion.trim() !== '');

  useEffect(() => { cargarHistorial(); }, []);

  const cargarHistorial = async () => {
    try {
      setCargando(true);
      const data = await certificacionesService.getMisSolicitudes();
      setHistorial(data || []);
    } catch { } finally { setCargando(false); }
  };

  const handleEnviar = async () => {
    if (!puedeEnviar) return;
    setEnviando(true); setError(null);
    try {
      const data = await certificacionesService.crearSolicitud({ tipo: form.tipo, especificacion: form.especificacion.trim() || null, comentarios: form.comentarios.trim() || null });
      setEntrega(data.fechaEntregaEstimada || null);
      setEnviado(true);
      await cargarHistorial();
    } catch (e) { setError(e?.response?.data?.error || 'Ocurrió un error al enviar la solicitud.'); }
    finally { setEnviando(false); }
  };

  const handleNueva = () => { setForm(ESTADO_INICIAL_FORM); setEnviado(false); setEntrega(null); };
  const nombre       = user?.name       || user?.nombre      || 'Colaborador';
  const departamento = user?.department || user?.departamento || '—';

  if (enviado) {
    const fechaFmt = entrega ? new Date(entrega + 'T12:00:00').toLocaleDateString('es-DO', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' }) : null;
    return (
      <div style={{ minHeight: '50vh', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '3rem 1.5rem' }}>
        <div style={{ maxWidth: '440px', width: '100%', textAlign: 'center' }}>
          <div style={{ width: '68px', height: '68px', background: C.greenBg, borderRadius: '50%', margin: '0 auto 1.5rem', display: 'flex', alignItems: 'center', justifyContent: 'center', border: `2px solid ${C.greenBorder}` }}>
            <IconCheck />
          </div>
          <h2 style={{ margin: '0 0 0.5rem', fontSize: '1.35rem', fontWeight: '700', color: C.text }}>Solicitud enviada</h2>
          <p style={{ margin: '0 0 1rem', fontSize: '0.875rem', color: C.textSub, lineHeight: '1.6' }}>
            Tu solicitud de <strong style={{ color: C.text }}>{TIPO_LABEL[form.tipo]}</strong> fue recibida. Recibirás una confirmación en tu correo.
          </p>
          {fechaFmt && (
            <div style={{ display: 'inline-flex', alignItems: 'center', gap: '0.5rem', margin: '0 0 1.5rem', padding: '0.55rem 1.2rem', background: C.amberBg, border: `1px solid ${C.amberBorder}`, borderRadius: '0.5rem', fontSize: '0.82rem', color: C.amber, fontWeight: '600' }}>
              <IconCalendar /> Entrega estimada: {fechaFmt}
            </div>
          )}
          <br />
          <div style={{ display: 'flex', gap: '0.75rem', justifyContent: 'center' }}>
            <button onClick={handleNueva} style={{ padding: '0.6rem 1.5rem', background: C.navy, border: 'none', borderRadius: '0.5rem', color: 'white', fontWeight: '700', fontSize: '0.85rem', cursor: 'pointer' }}>Nueva solicitud</button>
            <button onClick={() => { handleNueva(); setTab('historial'); }} style={{ padding: '0.6rem 1.5rem', background: 'white', border: `1px solid ${C.border}`, borderRadius: '0.5rem', color: C.textMid, fontWeight: '600', fontSize: '0.85rem', cursor: 'pointer' }}>Ver historial</button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div style={{ paddingBottom: '3rem' }}>
      <div style={{ background: C.amberBg, borderBottom: `1px solid ${C.amberBorder}`, padding: '0.8rem 2rem' }}>
        <div style={{ maxWidth: '780px', margin: '0 auto', display: 'flex', gap: '0.65rem', alignItems: 'flex-start' }}>
          <span style={{ color: C.amber, flexShrink: 0, marginTop: '1px' }}><IconInfo /></span>
          <p style={{ margin: 0, fontSize: '0.8rem', color: C.amber, lineHeight: '1.6', fontWeight: '500' }}>
            <strong>Importante:</strong> Las certificaciones se entregan los <strong>jueves</strong>. Las solicitudes se reciben hasta el <strong>martes al mediodía</strong>.
          </p>
        </div>
      </div>

      <div style={{ maxWidth: '780px', margin: '0 auto', padding: '2rem 1.5rem' }}>
        <div style={{ display: 'flex', gap: '0.25rem', marginBottom: '2rem', background: '#f1f5f9', padding: '0.25rem', borderRadius: '0.6rem', width: 'fit-content' }}>
          {[{ id: 'solicitar', label: 'Nueva Solicitud' }, { id: 'historial', label: `Historial (${historial.length})` }].map(t => (
            <button key={t.id} onClick={() => setTab(t.id)} style={{ padding: '0.5rem 1.25rem', border: 'none', borderRadius: '0.45rem', fontSize: '0.85rem', fontWeight: '600', cursor: 'pointer', background: tab === t.id ? 'white' : 'transparent', color: tab === t.id ? C.navy : C.textSub, boxShadow: tab === t.id ? '0 1px 4px rgba(0,0,0,0.08)' : 'none', transition: 'all 0.15s' }}>{t.label}</button>
          ))}
        </div>

        {tab === 'solicitar' && (
          <div>
            <div style={{ marginBottom: '1.5rem' }}>
              <h2 style={{ margin: '0 0 0.2rem', fontSize: '1.05rem', fontWeight: '700', color: C.text }}>Nueva Solicitud de Certificación Laboral</h2>
              <p style={{ margin: 0, fontSize: '0.82rem', color: C.textSub }}>Su solicitud será procesada por el Departamento de Recursos Humanos.</p>
            </div>
            <div style={{ background: C.bgCard, border: `1px solid ${C.border}`, borderRadius: '1rem', overflow: 'hidden', boxShadow: '0 2px 12px rgba(0,0,0,0.05)' }}>
              <div style={{ background: `linear-gradient(135deg, ${C.navy} 0%, ${C.navyMid} 60%, ${C.blue} 100%)`, padding: '1.4rem 2rem' }}>
                <p style={{ margin: '0 0 0.6rem', fontSize: '0.65rem', fontWeight: '700', color: 'rgba(255,255,255,0.45)', letterSpacing: '0.12em', textTransform: 'uppercase' }}>Datos del colaborador</p>
                <div style={{ display: 'flex', flexWrap: 'wrap', gap: '2rem' }}>
                  {[{ lbl: 'Nombre', val: nombre }, { lbl: 'Departamento', val: departamento }].map(({ lbl, val }) => (
                    <div key={lbl}>
                      <p style={{ margin: '0 0 0.1rem', fontSize: '0.68rem', color: 'rgba(255,255,255,0.5)', fontWeight: '600', letterSpacing: '0.06em', textTransform: 'uppercase' }}>{lbl}</p>
                      <p style={{ margin: 0, fontSize: '0.9rem', fontWeight: '700', color: 'white' }}>{val}</p>
                    </div>
                  ))}
                </div>
              </div>
              <div style={{ padding: '2rem' }}>
                <fieldset style={{ border: 'none', padding: 0, margin: '0 0 1.75rem' }}>
                  <legend style={{ display: 'block', fontSize: '0.75rem', fontWeight: '700', color: C.textMid, letterSpacing: '0.06em', textTransform: 'uppercase', marginBottom: '0.9rem' }}>Destinatario <span style={{ color: C.red }}>*</span></legend>
                  <div style={{ display: 'flex', flexDirection: 'column', gap: '0.65rem' }}>
                    {TIPOS.map(tipo => {
                      const sel = form.tipo === tipo.id;
                      return (
                        <div key={tipo.id}>
                          <label onClick={() => { setForm(p => ({ ...p, tipo: tipo.id, especificacion: '' })); setError(null); }} style={{ display: 'flex', alignItems: 'flex-start', gap: '0.9rem', padding: '0.9rem 1.1rem', border: `1.5px solid ${sel ? C.blue : C.border}`, borderRadius: '0.65rem', background: sel ? C.blueLight : C.bgCard, cursor: 'pointer', userSelect: 'none', transition: 'all 0.15s' }}>
                            <div style={{ width: '18px', height: '18px', flexShrink: 0, borderRadius: '50%', border: `2px solid ${sel ? C.blue : C.border}`, background: sel ? C.blue : 'white', display: 'flex', alignItems: 'center', justifyContent: 'center', marginTop: '2px' }}>
                              {sel && <div style={{ width: '7px', height: '7px', borderRadius: '50%', background: 'white' }} />}
                            </div>
                            <div>
                              <p style={{ margin: '0 0 0.1rem', fontSize: '0.875rem', fontWeight: '700', color: sel ? C.blue : C.text }}>{tipo.label}</p>
                              <p style={{ margin: 0, fontSize: '0.75rem', color: C.textSub }}>{tipo.descripcion}</p>
                            </div>
                          </label>
                          {sel && tipo.necesitaEspecificacion && (
                            <div style={{ marginTop: '0.4rem', paddingLeft: '0.4rem' }}>
                              <input type="text" autoFocus value={form.especificacion} onChange={e => setForm(p => ({ ...p, especificacion: e.target.value }))} placeholder={tipo.placeholder}
                                style={{ width: '100%', padding: '0.6rem 0.9rem', border: `1.5px solid ${form.especificacion ? C.blue : C.border}`, borderRadius: '0.45rem', fontSize: '0.875rem', color: C.text, outline: 'none', boxSizing: 'border-box', background: 'white' }}
                                onFocus={e => e.target.style.borderColor = C.blue} onBlur={e => e.target.style.borderColor = form.especificacion ? C.blue : C.border} />
                              {form.especificacion.trim() === '' && <p style={{ margin: '0.3rem 0 0', fontSize: '0.72rem', color: C.red }}>Por favor, especifique la entidad.</p>}
                            </div>
                          )}
                        </div>
                      );
                    })}
                  </div>
                </fieldset>
                <div style={{ borderTop: `1px solid ${C.border}`, marginBottom: '1.5rem' }} />
                <div style={{ marginBottom: '1.75rem' }}>
                  <label style={{ display: 'block', fontSize: '0.75rem', fontWeight: '700', color: C.textMid, letterSpacing: '0.06em', textTransform: 'uppercase', marginBottom: '0.55rem' }}>
                    Comentarios adicionales <span style={{ color: C.textLight, fontWeight: '400', textTransform: 'none', fontSize: '0.75rem', letterSpacing: 0 }}>(opcional)</span>
                  </label>
                  <textarea value={form.comentarios} onChange={e => setForm(p => ({ ...p, comentarios: e.target.value }))} rows={3}
                    placeholder="Requerimiento especial, fecha límite u otra información relevante..."
                    style={{ width: '100%', padding: '0.7rem 0.9rem', border: `1.5px solid ${C.border}`, borderRadius: '0.55rem', fontSize: '0.875rem', color: C.text, outline: 'none', resize: 'vertical', fontFamily: 'inherit', lineHeight: '1.55', boxSizing: 'border-box', background: 'white' }}
                    onFocus={e => e.target.style.borderColor = C.blue} onBlur={e => e.target.style.borderColor = C.border} />
                  <p style={{ margin: '0.3rem 0 0', fontSize: '0.72rem', color: C.textLight }}>{form.comentarios.length} caracteres</p>
                </div>
                {error && <div style={{ padding: '0.7rem 0.9rem', background: C.redBg, border: `1px solid ${C.redBorder}`, borderRadius: '0.45rem', fontSize: '0.8rem', color: C.red, marginBottom: '1.25rem' }}>{error}</div>}
                <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                  <button onClick={handleEnviar} disabled={!puedeEnviar || enviando} style={{ padding: '0.65rem 1.75rem', background: puedeEnviar && !enviando ? C.navy : C.border, border: 'none', borderRadius: '0.5rem', color: puedeEnviar && !enviando ? 'white' : C.textLight, fontWeight: '700', fontSize: '0.875rem', cursor: puedeEnviar && !enviando ? 'pointer' : 'not-allowed', display: 'flex', alignItems: 'center', gap: '0.5rem', transition: 'all 0.2s' }}>
                    {enviando ? <><Spinner />Enviando...</> : <><IconSend />Enviar solicitud</>}
                  </button>
                </div>
              </div>
            </div>
            <div style={{ marginTop: '1.25rem', padding: '0.9rem 1.25rem', background: C.bgCard, border: `1px solid ${C.border}`, borderLeft: `4px solid ${C.navy}`, borderRadius: '0.65rem', fontSize: '0.8rem', color: C.textSub, lineHeight: '1.6', display: 'flex', gap: '0.65rem', alignItems: 'flex-start' }}>
              <span style={{ color: C.navy, flexShrink: 0, marginTop: '1px' }}><IconNote /></span>
              <span><strong style={{ color: C.text }}>Nota: </strong>Las certificaciones se entregan los <strong>días jueves</strong>. Solicitudes recibidas después del <strong>martes al mediodía</strong> se procesan el siguiente jueves.</span>
            </div>
          </div>
        )}

        {tab === 'historial' && (
          <div>
            <h2 style={{ margin: '0 0 1.5rem', fontSize: '1.05rem', fontWeight: '700', color: C.text }}>Mis Solicitudes</h2>
            {cargando ? <p style={{ color: C.textSub, fontSize: '0.875rem' }}>Cargando...</p>
            : historial.length === 0 ? (
              <div style={{ textAlign: 'center', padding: '3rem', background: C.bgCard, border: `1px solid ${C.border}`, borderRadius: '0.75rem' }}>
                <p style={{ color: C.textSub, margin: 0 }}>Aún no tienes solicitudes de certificación.</p>
              </div>
            ) : (
              <div style={{ display: 'flex', flexDirection: 'column', gap: '0.75rem' }}>
                {historial.map(s => (
                  <div key={s.CertificacionID} style={{ background: C.bgCard, border: `1px solid ${C.border}`, borderRadius: '0.75rem', padding: '1.25rem 1.5rem', boxShadow: '0 1px 4px rgba(0,0,0,0.04)' }}>
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', flexWrap: 'wrap', gap: '0.5rem', marginBottom: '0.75rem' }}>
                      <div>
                        <p style={{ margin: '0 0 0.15rem', fontSize: '0.9rem', fontWeight: '700', color: C.text }}>{TIPO_LABEL[s.Tipo] || s.Tipo}</p>
                        {s.Especificacion && <p style={{ margin: 0, fontSize: '0.78rem', color: C.textSub }}>{s.Especificacion}</p>}
                      </div>
                      <EstadoBadge estado={s.Estado} />
                    </div>
                    <div style={{ display: 'flex', flexWrap: 'wrap', gap: '1.5rem' }}>
                      {[
                        { lbl: 'Solicitado',       val: formatFecha(s.FechaSolicitud)       },
                        { lbl: 'Entrega estimada', val: formatFecha(s.FechaEntregaEstimada) },
                        s.FechaCompletada && { lbl: 'Completada',   val: formatFecha(s.FechaCompletada) },
                        s.AtendidoPor     && { lbl: 'Atendida por', val: s.AtendidoPor },
                      ].filter(Boolean).map(({ lbl, val }) => (
                        <div key={lbl}>
                          <p style={{ margin: '0 0 0.1rem', fontSize: '0.68rem', fontWeight: '700', color: C.textLight, textTransform: 'uppercase', letterSpacing: '0.06em' }}>{lbl}</p>
                          <p style={{ margin: 0, fontSize: '0.82rem', color: C.textMid }}>{val}</p>
                        </div>
                      ))}
                    </div>
                    {s.DocumentoFirmadoPath && (
                      <div style={{ marginTop: '0.75rem' }}>
                        <a href={`${UPLOADS_URL}/uploads/${s.DocumentoFirmadoPath}`} target="_blank" rel="noopener noreferrer"
                          style={{ display: 'inline-flex', alignItems: 'center', gap: '0.4rem', fontSize: '0.78rem', color: C.blue, fontWeight: '600', textDecoration: 'none' }}>
                          <IconFile /> Ver certificación adjunta
                        </a>
                      </div>
                    )}
                  </div>
                ))}
              </div>
            )}
          </div>
        )}
      </div>
      <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
    </div>
  );
}

// ═══════════════════════════════════════════════════════════════
// VISTA DTHS
// ═══════════════════════════════════════════════════════════════
function VistaDTHS({ user }) {
  const [solicitudes, setSolicitudes]   = useState([]);
  const [cargando, setCargando]         = useState(true);
  const [filtroEstado, setFiltroEstado] = useState('todos');
  const [procesando, setProcesando]     = useState(null);
  const [tab, setTab]                   = useState('solicitudes'); // 'solicitudes' | 'plantillas'
  const [modalSolicitud, setModalSolicitud] = useState(null);

  useEffect(() => { cargar(); }, []);

  const cargar = async () => {
    try {
      setCargando(true);
      const data = await certificacionesService.getTodasLasSolicitudes();
      setSolicitudes(data || []);
    } catch { showNotification({ title: 'Error', message: 'Error al cargar solicitudes', color: 'red' }); }
    finally { setCargando(false); }
  };

  const cambiarEstado = async (id, nuevoEstado) => {
    setProcesando(id);
    try {
      await certificacionesService.actualizarEstado(id, nuevoEstado);
      showNotification({ title: 'Éxito', message: `Estado actualizado a "${nuevoEstado}"`, color: 'green' });
      await cargar();
    } catch (e) {
      showNotification({ title: 'Error', message: e?.response?.data?.error || 'Error al actualizar', color: 'red' });
    } finally { setProcesando(null); }
  };

  const filtradas = solicitudes.filter(s => filtroEstado === 'todos' || s.Estado === filtroEstado);
  const conteos = {
    todos: solicitudes.length,
    Pendiente:    solicitudes.filter(s => s.Estado === 'Pendiente').length,
    'En Proceso': solicitudes.filter(s => s.Estado === 'En Proceso').length,
    Completada:   solicitudes.filter(s => s.Estado === 'Completada').length,
    Rechazada:    solicitudes.filter(s => s.Estado === 'Rechazada').length,
  };

  const FILTROS    = [{ id: 'todos', label: 'Todas' }, { id: 'Pendiente', label: 'Pendientes' }, { id: 'En Proceso', label: 'En Proceso' }, { id: 'Completada', label: 'Completadas' }, { id: 'Rechazada', label: 'Rechazadas' }];
  const ACCIONES   = { Pendiente: [{ estado: 'En Proceso', label: 'Iniciar proceso', color: C.blue, bg: C.blueLight }, { estado: 'Rechazada', label: 'Rechazar', color: C.red, bg: C.redBg }], 'En Proceso': [{ estado: 'Completada', label: 'Marcar completada', color: C.green, bg: C.greenBg }, { estado: 'Rechazada', label: 'Rechazar', color: C.red, bg: C.redBg }], Completada: [], Rechazada: [{ estado: 'Pendiente', label: 'Reactivar', color: C.amber, bg: C.amberBg }] };

  return (
    <div style={{ background: C.bg, minHeight: '100vh', paddingBottom: '3rem', fontFamily: "'Segoe UI', system-ui, sans-serif" }}>

      {modalSolicitud && (
        <ModalGenerarCertificacion
          solicitud={modalSolicitud}
          onClose={() => setModalSolicitud(null)}
          onDocumentoSubido={cargar}
        />
      )}

      {/* Header */}
      <div style={{ background: `linear-gradient(135deg, ${C.navy} 0%, ${C.navyMid} 60%, ${C.blue} 100%)`, padding: '2rem 2.5rem' }}>
        <div style={{ maxWidth: '960px', margin: '0 auto' }}>
          <p style={{ margin: '0 0 0.25rem', fontSize: '0.68rem', fontWeight: '700', color: 'rgba(255,255,255,0.45)', letterSpacing: '0.14em', textTransform: 'uppercase' }}>Panel de Gestión — DTHS</p>
          <h1 style={{ margin: '0 0 1.5rem', fontSize: '1.4rem', fontWeight: '700', color: 'white' }}>Certificaciones Laborales</h1>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(130px, 1fr))', gap: '0.75rem' }}>
            {[{ label: 'Total', val: conteos.todos, color: 'rgba(255,255,255,0.9)' }, { label: 'Pendientes', val: conteos['Pendiente'], color: '#fbbf24' }, { label: 'En Proceso', val: conteos['En Proceso'], color: '#60a5fa' }, { label: 'Completadas', val: conteos['Completada'], color: '#4ade80' }].map(k => (
              <div key={k.label} style={{ background: 'rgba(255,255,255,0.08)', borderRadius: '0.65rem', padding: '0.9rem 1rem', border: '1px solid rgba(255,255,255,0.1)' }}>
                <p style={{ margin: '0 0 0.2rem', fontSize: '0.65rem', fontWeight: '700', color: 'rgba(255,255,255,0.5)', textTransform: 'uppercase', letterSpacing: '0.08em' }}>{k.label}</p>
                <p style={{ margin: 0, fontSize: '1.6rem', fontWeight: '800', color: k.color, lineHeight: 1 }}>{k.val}</p>
              </div>
            ))}
          </div>
        </div>
      </div>

      <div style={{ maxWidth: '960px', margin: '0 auto', padding: '2rem 1.5rem' }}>
        {/* Tabs */}
        <div style={{ display: 'flex', gap: '0.25rem', marginBottom: '1.75rem', background: '#f1f5f9', padding: '0.25rem', borderRadius: '0.6rem', width: 'fit-content' }}>
          {[{ id: 'solicitudes', label: `Solicitudes (${solicitudes.length})` }, { id: 'plantillas', label: 'Plantillas' }].map(t => (
            <button key={t.id} onClick={() => setTab(t.id)} style={{ padding: '0.5rem 1.25rem', border: 'none', borderRadius: '0.45rem', fontSize: '0.85rem', fontWeight: '600', cursor: 'pointer', background: tab === t.id ? 'white' : 'transparent', color: tab === t.id ? C.navy : C.textSub, boxShadow: tab === t.id ? '0 1px 4px rgba(0,0,0,0.08)' : 'none', transition: 'all 0.15s' }}>{t.label}</button>
          ))}
        </div>

        {/* Tab: Plantillas */}
        {tab === 'plantillas' && <GestionPlantillas user={user} />}

        {/* Tab: Solicitudes */}
        {tab === 'solicitudes' && (
          <>
            <div style={{ display: 'flex', gap: '0.4rem', flexWrap: 'wrap', marginBottom: '1.5rem' }}>
              {FILTROS.map(f => (
                <button key={f.id} onClick={() => setFiltroEstado(f.id)} style={{ padding: '0.45rem 1rem', border: `1px solid ${filtroEstado === f.id ? C.navy : C.border}`, borderRadius: '9999px', fontSize: '0.8rem', fontWeight: '600', cursor: 'pointer', background: filtroEstado === f.id ? C.navy : 'white', color: filtroEstado === f.id ? 'white' : C.textSub, transition: 'all 0.15s' }}>
                  {f.label} <span style={{ opacity: 0.7, fontWeight: '400' }}>({conteos[f.id] ?? conteos.todos})</span>
                </button>
              ))}
              <button onClick={cargar} style={{ marginLeft: 'auto', padding: '0.45rem 1rem', border: `1px solid ${C.border}`, borderRadius: '9999px', fontSize: '0.8rem', fontWeight: '600', cursor: 'pointer', background: 'white', color: C.textSub, display: 'flex', alignItems: 'center', gap: '0.4rem' }}>
                <IconRefresh /> Actualizar
              </button>
            </div>

            {cargando ? (
              <div style={{ textAlign: 'center', padding: '3rem', color: C.textSub, fontSize: '0.875rem' }}>Cargando solicitudes...</div>
            ) : filtradas.length === 0 ? (
              <div style={{ textAlign: 'center', padding: '4rem', background: C.bgCard, border: `1px solid ${C.border}`, borderRadius: '0.75rem' }}>
                <p style={{ color: C.textSub, margin: 0, fontSize: '0.9rem' }}>No hay solicitudes{filtroEstado !== 'todos' ? ` con estado "${filtroEstado}"` : ''}.</p>
              </div>
            ) : (
              <div style={{ display: 'flex', flexDirection: 'column', gap: '0.75rem' }}>
                {filtradas.map(s => {
                  const acciones  = ACCIONES[s.Estado] || [];
                  const enProceso = procesando === s.CertificacionID;
                  return (
                    <div key={s.CertificacionID} style={{ background: C.bgCard, border: `1px solid ${C.border}`, borderRadius: '0.85rem', padding: '1.25rem 1.5rem', boxShadow: '0 1px 4px rgba(0,0,0,0.04)', borderLeft: `4px solid ${ESTADO_CONFIG[s.Estado]?.dot || C.border}`, opacity: enProceso ? 0.7 : 1, transition: 'opacity 0.2s' }}>
                      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', flexWrap: 'wrap', gap: '0.75rem', marginBottom: '1rem' }}>
                        <div>
                          <p style={{ margin: '0 0 0.2rem', fontSize: '0.95rem', fontWeight: '700', color: C.text }}>{s.Colaborador}</p>
                          <p style={{ margin: 0, fontSize: '0.78rem', color: C.textSub }}>{s.Puesto}{s.Departamento ? ` · ${s.Departamento}` : ''}</p>
                        </div>
                        <EstadoBadge estado={s.Estado} />
                      </div>

                      <div style={{ background: C.bg, borderRadius: '0.5rem', padding: '0.75rem 1rem', marginBottom: '1rem' }}>
                        <p style={{ margin: '0 0 0.2rem', fontSize: '0.78rem', fontWeight: '700', color: C.textSub }}>
                          {TIPO_LABEL[s.Tipo] || s.Tipo}
                          {s.Especificacion && <span style={{ fontWeight: '400' }}> — {s.Especificacion}</span>}
                        </p>
                        {s.Comentarios && <p style={{ margin: '0.35rem 0 0', fontSize: '0.78rem', color: C.textSub, fontStyle: 'italic' }}>{s.Comentarios}</p>}
                      </div>

                      <div style={{ display: 'flex', flexWrap: 'wrap', gap: '1.25rem', marginBottom: '1rem' }}>
                        {[
                          { lbl: 'Solicitado',       val: formatFecha(s.FechaSolicitud)       },
                          { lbl: 'Entrega estimada', val: formatFecha(s.FechaEntregaEstimada) },
                          s.FechaCompletada && { lbl: 'Completada',   val: formatFecha(s.FechaCompletada) },
                          s.AtendidoPor     && { lbl: 'Atendida por', val: s.AtendidoPor },
                        ].filter(Boolean).map(({ lbl, val }) => (
                          <div key={lbl}>
                            <p style={{ margin: '0 0 0.1rem', fontSize: '0.65rem', fontWeight: '700', color: C.textLight, textTransform: 'uppercase', letterSpacing: '0.06em' }}>{lbl}</p>
                            <p style={{ margin: 0, fontSize: '0.82rem', color: C.textMid, fontWeight: '500' }}>{val}</p>
                          </div>
                        ))}
                      </div>

                      {/* Acciones + Generar */}
                      <div style={{ display: 'flex', gap: '0.5rem', flexWrap: 'wrap', paddingTop: '1rem', borderTop: `1px solid ${C.border}`, alignItems: 'center' }}>
                        {/* Botón principal: Generar certificación */}
                        <button onClick={() => setModalSolicitud(s)} style={{ display: 'flex', alignItems: 'center', gap: '0.4rem', padding: '0.45rem 1.1rem', border: `1px solid ${C.navy}`, borderRadius: '0.4rem', background: C.navy, color: 'white', fontSize: '0.8rem', fontWeight: '600', cursor: 'pointer', transition: 'all 0.15s' }}>
                          <IconNote /> Generar certificación
                        </button>

                        {/* Indicador documento adjunto */}
                        {s.DocumentoFirmadoPath && (
                          <a href={`${UPLOADS_URL}/uploads/${s.DocumentoFirmadoPath}`} target="_blank" rel="noopener noreferrer"
                            style={{ display: 'inline-flex', alignItems: 'center', gap: '0.4rem', padding: '0.45rem 0.85rem', border: `1px solid ${C.greenBorder}`, borderRadius: '0.4rem', background: C.greenBg, color: C.green, fontSize: '0.78rem', fontWeight: '600', textDecoration: 'none' }}>
                            <IconFile /> Documento firmado
                          </a>
                        )}

                        <div style={{ marginLeft: 'auto', display: 'flex', gap: '0.4rem' }}>
                          {acciones.map(a => (
                            <button key={a.estado} onClick={() => cambiarEstado(s.CertificacionID, a.estado)} disabled={enProceso}
                              style={{ padding: '0.45rem 1.1rem', border: `1px solid ${a.color}33`, borderRadius: '0.4rem', background: a.bg, color: a.color, fontSize: '0.8rem', fontWeight: '600', cursor: enProceso ? 'not-allowed' : 'pointer', transition: 'all 0.15s' }}>
                              {enProceso ? '...' : a.label}
                            </button>
                          ))}
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
            )}
          </>
        )}
      </div>
      <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
    </div>
  );
}

// ═══════════════════════════════════════════════════════════════
// COMPONENTE PRINCIPAL
// ═══════════════════════════════════════════════════════════════
export default function CertificacionesModule() {
  const { user, loading } = useAuth();

  if (loading || !user) {
    return (
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: '40vh' }}>
        <span style={{ width: '20px', height: '20px', border: '2px solid #e2e8f0', borderTopColor: '#1e5cb3', borderRadius: '50%', animation: 'spin 0.7s linear infinite', display: 'inline-block' }} />
        <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
      </div>
    );
  }

  const rolNorm = (user?.rawRole || '').toLowerCase().trim();
  const esDTHS  = ROLES_DTHS.includes(rolNorm);

  return esDTHS
    ? <VistaDTHS user={user} />
    : <VistaColaborador user={user} />;
}
